import m from 'mithril';
import { APP_TITLE } from './appinfo';

export class Header {
  view(vnode) {
    return m("header.navbar.navbar-expand-lg.navbar-light.bg-light", 
      m("div.container-fluid", 
        m("a.navbar-brand", { href: "#" }, APP_TITLE),
        m("button.navbar-toggler", { type: "button", "data-bs-toggle": "collapse", "data-bs-target": "#navbarSupportedContent" }, 
          m("span.navbar-toggler-icon")
        ),
      ),
    );
  }
}

export class MainContent {
  view(vnode) {
    return m("main.container.pt-2.pb-2", vnode.children);
  }
}

export class Footer {
  view(vnode) {
    return m("footer.footer.bg-light.text-center.text-lg-start", 
      m("div.text-center.p-3", "©Hamajima Shoten, Publishers"),
    );
  }
}